import React from 'react'
import styled from 'styled-components/macro'
import { rem, em } from '../../../utils/styles'

import { ReactComponent as ArrowDropDownIcon } from '../../Icons/icon-chevron.svg'
import { ReactComponent as CloseIcon } from '../../Icons/icon-plus.svg'

const AutocompleteButton = styled.button`
  position: relative;
  border: 0;
  padding: 0;
  margin: 0;
  background-color: transparent;
  width: ${rem(32)};
  height: ${rem(32)};
  cursor: pointer;
  z-index: 3;
`

const ArrowDropDown = styled(ArrowDropDownIcon)`
  transform: rotate(90deg);
  height: ${em(18)};
`

const Close = styled(CloseIcon)`
  transform: rotate(45deg);
  height: ${em(18)};
`

export function AutocompleteClearButton(props) {
  return (
    <AutocompleteButton {...props}>
      <Close />
    </AutocompleteButton>
  )
}

export function AutocompleteToggleButton(props) {
  return (
    <AutocompleteButton {...props}>
      <ArrowDropDown width='24px' height='24px' />
    </AutocompleteButton>
  )
}

export default AutocompleteButton
